module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-12.9a7e8942.png";